module.exports = __webpack_public_path__ + "static/ozharvest-437cba4d30229e07fc0590748771abf7.png";